import { PosModel } from '@/types'

/** `color` is a token family; product tiles use it for their placeholder tint. */
export const demoCategories: PosModel.Category[] = [
  { _id: 'cat-bev', name: 'Beverages', color: 'info' },
  { _id: 'cat-bak', name: 'Bakery', color: 'cta' },
  { _id: 'cat-dai', name: 'Dairy & Eggs', color: 'violet' },
  { _id: 'cat-sna', name: 'Snacks', color: 'warning' },
  { _id: 'cat-gro', name: 'Grocery', color: 'success' },
  { _id: 'cat-per', name: 'Personal Care', color: 'error' },
  { _id: 'cat-hom', name: 'Home', color: 'grey' },
]
